import { render, staticRenderFns } from "./MoleculeDataTable.vue?vue&type=template&id=d1977e76&scoped=true&"
import script from "./MoleculeDataTable.vue?vue&type=script&lang=js&"
export * from "./MoleculeDataTable.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeDataTable.vue?vue&type=style&index=0&id=d1977e76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1977e76",
  null
  
)

export default component.exports